import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import AuthorizedRoute from 'commons-ui/src/permission/AuthorizedRoute';
import GstList from './TDSList';
import { FINANCE_RESOURCES, URL as TdsUrl } from '../helper';
import { URL, COMPONENT, TDS_ABSORPTION_RESOURCES, GET_ACTION } from './tdsHelper';

const TdsAbsorptionDashboardHome: React.FC = () => {
	return (
		<>
			<Switch>
				<AuthorizedRoute
					exact
					configPageName='finance'
					configResourceName='tdsAbsorption'
					configActionName='toGetAllTDSAbsorptionCards'
					path={TdsUrl.tdsAbsorption}
					component={GstList}
				/>
				{_map(_values(TDS_ABSORPTION_RESOURCES), (subEntity) => (
					<AuthorizedRoute
						key={subEntity}
						configPageName={FINANCE_RESOURCES.tdsAbsorption}
						configResourceName={subEntity}
						configActionName={GET_ACTION[subEntity][subEntity]}
						path={URL[subEntity]}
						component={COMPONENT[subEntity]}
					/>
				))}
				<Redirect to={TdsUrl.tdsAbsorption} />
			</Switch>
		</>
	);
};

export default TdsAbsorptionDashboardHome;
